export default __webpack_public_path__ + "static/media/Archetype_HTB.2232be45.md";